import {saveData} from './utils';
import Analytics from './analytics';
import {sendCallTouchRequest} from './calltouch';

const classNames = {
  INPUT_INVALID: `js-input-invalid`
};
const texts = {
  success: {
    ru: `Ваш запрос принят,<br/>в ближайшее время мы с Вами свяжемся`,
    en: `Your message has been successfully sent`,
    cn: `提交成功`
  }
};

export default class Form {
  constructor(id, type) {
    this.locale = document.querySelector(`body`).dataset.lang;
    this.form = document.getElementById(`${id}`);
    this.yaGoal = this.form.dataset && this.form.dataset.yaGoalAttr || null;
    this.gaGoal = this.form.dataset && this.form.dataset.gaGoalAttr || null;
    this.name = this.form.querySelector(`#${type}-name`);
    this.mail = this.form.querySelector(`#${type}-email`);
    this.phone = this.form.querySelector(`#${type}-phone`);
    this.message = this.form.querySelector(`#${type}-message`);
    this.agreement = this.form.querySelector(`#${type}-agreement`);
    this.textInputs = [...this.form.querySelectorAll(`.page-form__input input[type="text"]`)];
    this.textareas = [...this.form.querySelectorAll(`.page-form__textarea`)];
    this.checkboxes = [...this.form.querySelectorAll(`input[type="checkbox"]`)];
    this.isValid = false;
  }

  init() {
    this.setHandlers();
  }

  setHandlers() {
    this._addInputsHandlers();
    this.onSubmit();
  }

  _addInputsHandlers = () => {
    const inputs = [
      ...this.textInputs,
      ...this.textareas
    ];
    const checkboxes = [...this.checkboxes];
    const labeledInputs = [
      ...this.textInputs.filter(input => input.closest(`.page-form__input--labeled`)),
      ...this.textareas.filter(textarea => textarea.classList.contains(`page-form__textarea--labeled`))
    ];

    if (labeledInputs.length) {
      labeledInputs.forEach(input => {
        input.addEventListener(`focus`, ({currentTarget}) => {
          this._toggleLabels(currentTarget, true);
        });

        input.addEventListener(`blur`, ({currentTarget}) => {
          this._toggleLabels(currentTarget, !!currentTarget.value);
        })
      });
    }

    inputs.forEach(input => {
      input.addEventListener(`keyup`, () => {
        input.closest(`div`).classList.remove(classNames.INPUT_INVALID);
      });
    });

    checkboxes.forEach(checkbox => {
      checkbox.addEventListener(`change`, () => {
        checkbox.closest(`div`).classList.remove(classNames.INPUT_INVALID);
      });
    })
  };

  onSubmit = () => {
    this.form.addEventListener(`submit`, e => {
      e.preventDefault();

      const data = new FormData(e.target);

      this.checkInputs();

      if (this.isValid) {
        this.saveData(data)
          .then(() => {
            this.renderSuccess();
          })
      }
    })
  };

  renderSuccess = () => {
    const content = document.createElement(`div`);

    content.className = `page-form__result`;
    content.innerHTML = `${texts[`success`][this.locale]}.`;

    this.form.innerHTML = ``;
    this.form.appendChild(content);
  };

  checkInputs() {
    const isValidName = !!this.name.value;
    const isValidPhone = !!this.phone.value &&  !/[a-zA-Z_]/.test(this.phone.value);
    const isValidMail = !!this.mail.value && /\S+@\S+\.\S+/.test(this.mail.value);
    const isValidMessage = !!this.message.value;
    const isValidCheckbox = !!this.agreement.checked;

    if (!isValidName) {
      this.name.closest(`div`).classList.add(classNames.INPUT_INVALID);
    }

    if (!isValidPhone) {
      this.phone.closest(`div`).classList.add(classNames.INPUT_INVALID);
    }

    if (!isValidMail) {
      this.mail.closest(`div`).classList.add(classNames.INPUT_INVALID);
    }

    if (!isValidMessage) {
      this.message.closest(`div`).classList.add(classNames.INPUT_INVALID);
    }

    if (!isValidCheckbox) {
      this.agreement.closest(`div`).classList.add(classNames.INPUT_INVALID);
    }

    this.isValid = isValidName && isValidMail && isValidPhone && isValidMessage && isValidCheckbox;
  }

  saveData = (data) => {
    const responseAddress = `/responses`;

    if (typeof yaCounter28019928 !== 'undefined' && this.yaGoal !== null)
      yaCounter28019928.reachGoal(this.yaGoal);

    if (typeof gtag !== 'undefined' && this.gaGoal !== null)
      gtag('event', 'contacts_form', {'event_category': this.gaGoal, 'event_action': 'send'});

    if (typeof gtag !== 'undefined')
      gtag('event', 'mail-send');

    Analytics.fireEvent('SendPresentationForm');

    sendCallTouchRequest(data);

    return saveData(data, responseAddress);
  };

  _toggleLabels(input, state) {
    const label = input.closest(`.page-form__input`).querySelector(`label`);

    label.classList.toggle(`page-form__label--moved`, state);
  }
}
